import { render, staticRenderFns } from "./TokenInput.vue?vue&type=template&id=4fe286e2&scoped=true"
import script from "./TokenInput.vue?vue&type=script&lang=js"
export * from "./TokenInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe286e2",
  null
  
)

export default component.exports